// src/components/Footer.js (VERSIÓN FINAL CON RUTA DE LIBROS CORREGIDA)

import React from 'react';
import { useNavigate } from 'react-router-dom'; 
import './Footer.css'; 
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';
import { FaWhatsapp, FaFacebookF, FaInstagram, FaTiktok } from 'react-icons/fa'; 

const Footer = () => { 
    const navigate = useNavigate(); 
    
    const handleNavigate = (path) => {
        navigate(path); 
        window.scrollTo(0, 0); 
    };
    
    const socialLinks = [
        { icon: FaFacebookF, url: "https://www.facebook.com/GioScarvaciAsociados", label: "Facebook" },
        { icon: FaInstagram, url: "https://www.instagram.com/gioscarvaciyasociados", label: "Instagram" },
        { icon: FaTiktok, url: "https://www.tiktok.com/@tu_usuario", label: "TikTok" }, // Recuerda actualizar este link
    ];
    
    return (
        <footer className="footer-container">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>Giovanni Scarvaci & Asociados</h3>
                    <p>Consultoría Legal y Estratégica de Élite.</p>
                    
                    <div className="social-icons">
                        {socialLinks.map((link, index) => (
                            <a 
                                key={index}
                                href={link.url} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                aria-label={link.label}
                            >
                                <link.icon />
                            </a>
                        ))}
                    </div>
                </div>
                
                <div className="footer-section">
                    <h3>Contacto</h3>
                    <p><FiMapPin /> Sede Principal, Maracay-Estado Aragua, Venezuela</p>
                    <p><FiPhone /> +1 (407) 873-8172</p> 
                    <p><FiMail /> giovanniscarvaciyasociados@gmail.com</p>
                </div>

                <div className="footer-section quick-links">
                    <h3>Enlaces Rápidos</h3>
                    <button onClick={() => handleNavigate('/servicios')}>Nuestros Servicios</button>
                    
                    {/* ✅ CORRECCIÓN: Ahora apunta a '/libros' que es la ruta de BooksCatalog en App.js */}
                    <button onClick={() => handleNavigate('/libros')}>Tienda de Libros</button>
                    
                    <button onClick={() => handleNavigate('/politicas-de-privacidad')}>Política de Privacidad</button> 
                </div>

                <div className="footer-section">
                    <h3>Comunícate</h3>
                    <a 
                        href="https://wa.me/14078738172" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="cta-button whatsapp-button"
                    >
                        <FaWhatsapp style={{ marginRight: '8px' }} /> WhatsApp Directo
                    </a>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {new Date().getFullYear()} Giovanni Scarvaci & Asociados. Todos los derechos reservados.</p>
            </div>
        </footer>
    );
};

export default Footer;